/* eslint-disable @typescript-eslint/no-unused-vars */

export const scrollbarStyle = ({ palette = {} }) => ({
  '& .footer .scrollbar': {
    '& .flex-cell': {
      padding: 0,
    },

    '& ::-webkit-scrollbar': {
      height: 12,
      width: 12,
    },
    '& ::-webkit-scrollbar-track': {
      background: '#f1f1f1',
    },
    '& ::-webkit-scrollbar-thumb': {
      background: '#c1c1c1',
    },
    '& ::-webkit-scrollbar-thumb:hover': {
      background: '#a8a8a8',
    },
  },
});
